import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { AnimatedWidthButton } from "app/features/product/components/animatedWidthButton/AnimatedWidthButton";
import { FilterSortPopover } from "app/features/product/components/filterSortPopover/FilterSortPopover";
import { useState } from "react";
import PropTypes from "prop-types";
import { SortPopoverForm } from "./SortPopoverForm";
import { Formik } from "formik";
import { useSortContext } from "../../contexts/SortProvider";
import { FormattedMessage } from "react-intl";
import { getSortLabelKey } from "../../utils/getSortLabelKey";
import { ArrowUpDownIcon } from "../../icons/ArrowUpDownIcon";

export const SortPopover = ({ facetId = "sortBy", onOpen, onClose, onToggle }) => {
	const { sortBy, setSortBy } = useSortContext();
	const [isOpen, setIsOpen] = useState(false);

	const handleSubmit = values => {
		setSortBy(values?.sort);
		setIsOpen(false);
	};

	return (
		<FilterSortPopover.Root
			id={facetId}
			open={isOpen}
			onOpenChange={setIsOpen}
			onOpen={onOpen}
			onClose={onClose}
			onToggle={onToggle}
		>
			<FilterSortPopover.Trigger>
				<AnimatedWidthButton isActive={isOpen} isOpen={isOpen} data-testid="sort-by-button">
					<ArrowUpDownIcon />
					<Typography component="span" variant={TYPOGRAPHY_VARIANTS.SMALL}>
						<FormattedMessage id="sort.sort.by" /> :{" "}
						<Typography component="span" isBold variant={TYPOGRAPHY_VARIANTS.SMALL}>
							<FormattedMessage id={getSortLabelKey(sortBy)} />
						</Typography>
					</Typography>
				</AnimatedWidthButton>
			</FilterSortPopover.Trigger>

			<FilterSortPopover.Content>
				<Formik initialValues={{ sort: sortBy }} onSubmit={handleSubmit} enableReinitialize>
					<SortPopoverForm />
				</Formik>
			</FilterSortPopover.Content>
		</FilterSortPopover.Root>
	);
};

SortPopover.propTypes = {
	facetId: PropTypes.string.isRequired,
	onOpen: PropTypes.func,
	onClose: PropTypes.func,
	onToggle: PropTypes.func,
};
